// import axios from "axios";
// import { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// import "./Appointment.css";

// const AppointmentList = () => {
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
//   const [appointments, setAppointments] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedDate, setSelectedDate] = useState(""); // "" means no date selected

//   /* ================= FETCH DATA ================= */

//   const fetchAppointments = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/admin/appointments`, {
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//         },
//       });
//       setAppointments(response.data.data || response.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     fetchAppointments();
//   }, []);

//   /* ================= UPDATE STATUS ================= */

//   const updateStatus = async (id, currentStatus) => {
//     const newStatus =
//       currentStatus === "pending" ? "completed" : "pending";

//     const confirm = await Swal.fire({
//       title: "Are you sure?",
//       text: `Mark as ${newStatus}?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, Update",
//     });

//     if (confirm.isConfirmed) {
//       try {
//         await axios.put(
//           `${API_BASE_URL}/admin/appointments/${id}`,
//           { appointmentStatus: newStatus },
//           {
//             headers: {
//               Authorization: "Bearer " + localStorage.getItem("token"),
//             },
//           }
//         );

//         Swal.fire("Updated!", "Status updated successfully.", "success");
//         fetchAppointments();
//       } catch (error) {
//         Swal.fire("Error!", "Failed to update status.", "error");
//       }
//     }
//   };

//   /* ================= FILTER ================= */

//   const filteredAppointments = appointments.filter((item) =>
//     item.fullName.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="appointment-container">
//       <h2 className="page-title">Appointments</h2>

//       <input
//         type="text"
//         placeholder="Search by Name..."
//         className="search-input"
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//       />
//       <div>
//         <label>Date Filter</label>
//         <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
//         <button onClick={fetchAppointments}>Filter</button>

//       </div>

//       <div className="appointment-grid">
//         {filteredAppointments.map((item) => (
//           <div key={item._id} className="appointment-card">
//             <div className="card-header">
//               <h3>{item.fullName}</h3>
//               <span
//                 className={`status-badge ${item.appointmentStatus === "pending"
//                     ? "pending"
//                     : "completed"
//                   }`}
//               >
//                 {item.appointmentStatus}
//               </span>
//             </div>

//             <div className="card-body">
//               <p><strong>Course:</strong> {item.course}</p>
//               <p><strong>Duration:</strong> {item.courseDuration}</p>
//               <p><strong>Date:</strong> {item.consultancyDate}</p>
//               <p><strong>Time:</strong> {item.consultancyTime}</p>
//               <p><strong>Mode:</strong> {item.consultancyMode}</p>
//               <p><strong>Price:</strong> ₹{item.price}</p>
//               <p><strong>Contact:</strong> {item.contactNumber}</p>
//               <p><strong>Email:</strong> {item.email}</p>
//             </div>

//             <button
//               className="status-btn"
//               onClick={() =>
//                 updateStatus(item._id, item.appointmentStatus)
//               }
//             >
//               Change Status
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AppointmentList;



import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./Appointment.css";

const AppointmentList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [appointments, setAppointments] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  // ✅ Fetch appointments (backend handles date filter)
  const fetchAppointments = async (date = "") => {
    try {
      const params = {};
      if (date) params.date = date;

      const response = await axios.get(`${API_BASE_URL}/admin/appointments`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        params,
      });

      console.log("API Data:", response.data.data); // debug
      setAppointments(response.data.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch appointments", "error");
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  // ✅ Update status
  const updateStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "pending" ? "completed" : "pending";

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `Mark as ${newStatus}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.put(
          `${API_BASE_URL}/admin/appointments/${id}`,
          { appointmentStatus: newStatus },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        Swal.fire("Updated!", "Status updated successfully.", "success");

        // ✅ Refetch with current date filter
        fetchAppointments(selectedDate);
      } catch (error) {
        Swal.fire("Error!", "Failed to update status.", "error");
      }
    }
  };

  // ✅ ONLY search filter (no date filtering here)
  const filteredAppointments = appointments.filter((item) =>
    item.fullName.toLowerCase().includes(search.toLowerCase())
  );

  // ✅ Apply date filter (calls backend)
  const handleDateFilter = () => {
    fetchAppointments(selectedDate);
  };

  return (
    <div className="appointment-container">
      <h1 className="page-title">Appointments</h1>

      {/* Filters */}
      <div className="filters">
        <input
          type="text"
          placeholder="Search by Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="date-filter">
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />

          <button className="primary-btn" onClick={handleDateFilter}>
            Filter
          </button>

          <button
            className="secondary-btn"
            onClick={() => {
              setSelectedDate("");
              fetchAppointments();
            }}
          >
            Reset
          </button>
        </div>
      </div>

      {/* Appointments */}
      <div className="appointment-grid">
        {filteredAppointments.length > 0 ? (
          filteredAppointments.map((item) => (
            <div key={item._id} className="appointment-card">
              <div className="card-header">
                <h3>{item.fullName}</h3>
                <span className={`status-badge ${item.appointmentStatus}`}>
                  {item.appointmentStatus}
                </span>
              </div>

              <div className="card-body">
                <p><strong>Course:</strong> {item.course}</p>
                <p><strong>Duration:</strong> {item.courseDuration}</p>
                <p><strong>Date:</strong> {item.consultancyDate}</p>
                <p><strong>Time:</strong> {item.consultancyTime}</p>
                <p><strong>Mode:</strong> {item.consultancyMode}</p>
                <p><strong>Price:</strong> ₹{item.price}</p>
                <p><strong>Contact:</strong> {item.contactNumber}</p>
                <p><strong>Email:</strong> {item.email}</p>
              </div>

              <button
                className="primary-btn"
                onClick={() =>
                  updateStatus(item._id, item.appointmentStatus)
                }
              >
                Change Status
              </button>
            </div>
          ))
        ) : (
          <p className="no-data">No Appointments Found</p>
        )}
      </div>
    </div>
  );
};

export default AppointmentList;

